export enum UploadStepEnum {
    UPLOAD = 1,
    CONFIRM = 2
}
